import React, { isValidElement } from 'react';

// This function collects all anchors from children where `highlight` is a string
export const getAnchorsFromChildren = (children: React.ReactNode): string[] => {
  return React.Children.toArray(children).reduce((acc: string[], child) => {
    if (
      isValidElement(child) &&
      Object.keys(child.props).includes('highlight') &&
      typeof child.props.highlight === 'string'
    ) {
      const anchor = child.props.highlight.replace(
        /[.*+?^${}()|[\]\\]/g,
        '\\$&',
      );

      return [...acc, anchor];
    }
    return acc;
  }, []);
};
